<template>
  <div>
    <b-card>
      <div slot="header">
        {{ $lang.azmoonLang.choose_azmoon_execute_person }}

        <span
          key="fa-info-circle"
          v-b-tooltip.hover
          :title="$lang.azmoonLang.choose_azmoon_execute_person_tooltip"
        >
          <i class="fa fa-info-circle fa-lg text-info"></i>
        </span>
      </div>
      <div class="alert alert-warning" role="alert">
        <div class="detail_body">
          <div class="open-tab">
            <h6>
              راهنما : انتخاب مخاطب الزامی می باشد، اما انتخاب اپراتور و معرف
              اختیاری است
              <!-- {{$lang.azmoonLang.choose_azmoon_execute_person_tooltip}} -->
            </h6>
          </div>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-row
            v-for="(v, index) in $v.items.$each.$iter"
            :key="index"
            class="my-2"
          >
            <b-col class="px-main-1" cols="12" md="4">
              <label v-if="index == 0" class="mt-2 d-none d-md-block" for="">{{
                $lang.azmoonLang.azmoon_person
              }}</label>
              <label class="d-block d-md-none" for="">{{
                $lang.azmoonLang.azmoon_person
              }}</label>
              <selectAsync
                :options="person_options"
                v-model="v.person.$model"
                label="caption"
                :asyncFind="getAvailablePerson"
                :isValid="v.person.$dirty ? !v.person.$error : null"
                :loading="personLoading"
                :placeholder="$lang.azmoonLang.azmoon_person"
              />
            </b-col>
            <b-col class="px-main-1" cols="12" md="4">
              <label v-if="index == 0" class="mt-2 d-none d-md-block" for="">{{
                $lang.azmoonLang.azmoon_operator
              }}</label>
              <label class="d-block d-md-none" for="">{{
                $lang.azmoonLang.azmoon_operator
              }}</label>
              <selectAsync
                :options="operator_options"
                v-model="v.operator.$model"
                label="caption"
                :asyncFind="getOperator"
                :isValid="v.operator.$dirty ? !v.operator.$error : null"
                :loading="operatorLoading"
                :placeholder="$lang.azmoonLang.search.place_holder"
              />
            </b-col>
            <b-col class="px-main-1" cols="12" md="3">
              <label v-if="index == 0" class="mt-2 d-none d-md-block" for="">{{
                $lang.azmoonLang.azmoon_reference
              }}</label>
              <label class="d-block d-md-none" for="">{{
                $lang.azmoonLang.azmoon_reference
              }}</label>
              <selectAsync
                :options="reference_options"
                v-model="v.reference.$model"
                label="caption"
                :asyncFind="getReference"
                :isValid="v.reference.$dirty ? !v.reference.$error : null"
                :loading="referenceLoading"
                :placeholder="$lang.azmoonLang.search.place_holder"
              />
            </b-col>
            <b-col class="px-main-1" cols="12" md="1">
              <label v-if="index == 0" for="">&nbsp;&nbsp;</label
              ><br v-if="index == 0" />
              <b-button
                v-if="index == 0"
                variant="success"
                @click="add"
                class="mt-main-2 mr-1"
              >
                <i class="fa fa-plus"></i>
              </b-button>
              <b-button
                v-if="index > 0"
                variant="danger"
                :class="index == 0 ? `mt-main-2` : `mt-1`"
                @click="deleteItem(index)"
              >
                <i class="fa fa-minus-circle"></i>
              </b-button>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col>
              <b-button variant="success" @click="add" class="">
                {{ $lang.azmoonLang.add_new_item }}
                <i class="fa fa-plus"></i>
              </b-button>
            </b-col>
          </b-row> -->
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "azmoon-execute-person-form",
  validations: {
    items: {
      required,
      $each: {
        person: {
          required,
        },
        operator: {},
        reference: {},
      },
    },
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    azmoon_execute_id: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      items: [
        {
          person: null,
          operator: null,
          reference: null,
        },
      ],
      azmoon_execute_person_url: "",
      available_operator: null,
      person_url: this.$config.api_url + this.$config.azmoon.person_combo,
      person_options: [],
      person_selected: null,
      personLoading: false,
      operator_options: [],
      operator_selected: null,
      operatorLoading: false,
      reference_options: [],
      reference_selected: null,
      referenceLoading: false,
      openText: false,
    };
  },
  methods: {
    toggle() {
      this.openText = !this.openText;
    },
    handleBack() {
      this.$emit("cancel");
    },
    deleteItem(index) {
      if (index == 0) {
        return;
      }
      this.items.splice(index, 1);
    },
    add() {
      this.items.push({
        person: null,
        operator: null,
        reference: null,
      });
    },
    async getAvailablePerson(query) {
      if (!query || query.length < 2) {
        this.place_birth_options = [];
        return;
      }
      this.personLoading = true;
      try {
        let url = this.azmoon_execute_person_url;
        let params = {
          search_txt: query,
        };
        const response = await this.$httpService.get(url, params);
        let persons = response.data.data.result;
        persons = persons.map((item) => {
          const { name, family, national_code } = item.person;
          const { parvandeh_number } = item;
          return {
            id: item.parvandeh_code,
            caption: `${parvandeh_number} ${name} ${family} ${national_code}`,
          };
        });
        this.person_options = persons;
      } catch (error) {
        this.$generateError(error);
        this.person_options = [];
      } finally {
        this.personLoading = false;
      }
    },
    async getOperator(query) {
      if (!query || query.length < 2) {
        this.place_birth_options = [];
        return;
      }
      this.operatorLoading = true;
      try {
        let url = this.available_operator;
        let params = {
          search_txt: query,
        };
        const response = await this.$httpService.get(url, params);
        let operators = response.data.data.result;
        operators = operators.map((item) => {
          const { name, family, national_code } = item.person;
          const { parvandeh_number, parvandeh_code } = item;
          return {
            id: parvandeh_code,
            caption: ` ${parvandeh_number} ${name} ${family} ${national_code}`,
          };
        });
        this.operator_options = operators;
      } catch (error) {
        this.$generateError(error);
        this.operator_options = [];
      } finally {
        this.operatorLoading = false;
      }
    },
    async getReference(query) {
      if (!query || query.length < 2) {
        this.place_birth_options = [];
        return;
      }
      this.referenceLoading = true;
      try {
        let url = this.person_url;
        let params = {
          search_txt: query,
        };
        const response = await this.$httpService.get(url, params);
        let references = response.data.data;
        references = references.map((item) => {
          const { name, national_code, code } = item;
          // const {parvandeh_number} = item
          return {
            id: code,
            caption: ` ${name ? name : ``}  ${
              national_code ? national_code : ``
            }`,
          };
        });
        this.reference_options = references;
      } catch (error) {
        this.$generateError(error);
        this.reference_options = [];
      } finally {
        this.referenceLoading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      if (this.selected == 2) {
        this.is_image = 0;
      }
      let payload = {
        is_enable: this.is_enable,
        option_description: this.option_description,
        is_image: this.is_image,
      };
      this.$emit("submit", payload);
    },
    async fetchData() {
      let p = this.getAvailablePerson();
      let o = this.getOperator();
      let r = this.getReference();
      let res = [await p, await o, await r];
    },
  },
  async created() {
    // this.getValue()
    this.azmoon_execute_person_url =
      this.$config.api_url +
      this.$config.azmoon.available_person.replace(
        "{0}",
        this.azmoon_execute_id
      );

    this.available_operator =
      this.$config.api_url +
      this.$config.azmoon.available_operator.replace(
        "{0}",
        this.azmoon_execute_id
      );
    await this.fetchData();
  },
  watch: {
    value() {
      this.items = this.value;
    },
  },
};
</script>

<style>
</style>
